import { centralizedAuth as CentralizedAuth } from '@cimpress/simple-auth-wrapper';

const isBrowser = typeof window !== 'undefined';

// GATSBY_CLIENT_ID is automatically exposed to the browser by Gatsby.
// CLIENT_ID requires gatsby-plugin-env-variables.
const clientID =
  process.env.GATSBY_CLIENT_ID ||
  process.env.CLIENT_ID ||
  'EXIjIaxPbdB1kmcxYMJgZ9V1NqMQrckm';

// eslint-disable-next-line import/no-mutable-exports
let auth = null;
if (isBrowser) {
  try {
    auth = new CentralizedAuth({
      clientID,
      redirectRoute: '/',
      authorizeParams: { connection: 'cimpress-okta' },
    });
  } catch (e) {
    console.error('[auth] Failed to initialize centralizedAuth:', e);
  }
}

export const getAuthorizationHeaderAndShopperId = () => ({
  idToken: isBrowser ? `Bearer ${auth.getAccessToken()}` : null,
  isSignedIn: isBrowser ? auth.isLoggedIn() : false,
});

export const logout = () => isBrowser && auth.logout();

export default auth;
